import { Routes } from '@angular/router';

// Customer Components
import { CustomerHomeComponent } from './components/customer-home/customer-home.component';
import { CartComponent } from './components/cart/cart.component';
import { EditItemComponent } from './components/edit-item/edit-item.component';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { OrderHistoryComponent } from './components/order-history/order-history.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { VoiceRecongnitionPermissionsComponent } from './components/voice-recongnition-permissions/voice-recongnition-permissions.component';

export const customerRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: CustomerHomeComponent
  },
  {
    path: 'cart',
    component: CartComponent
  },
  {
    path: 'edit-item/:id',
    component: EditItemComponent
  },
  {
    path: 'order-details/:id',
    component: OrderDetailsComponent
  },
  {
    path: 'order-history',
    component: OrderHistoryComponent
  },
  {
    path: 'payments',
    component: PaymentsComponent
  },
  {
    path: 'voice-permissions',
    component: VoiceRecongnitionPermissionsComponent
  }
]; 